import { saveAs } from 'file-saver';
import { Document, Packer, Paragraph, TextRun, HeadingLevel } from 'docx';

export function downloadAsTxt(content: string) {
  try {
    const blob = new Blob([content], { type: 'text/plain;charset=utf-8' });
    saveAs(blob, 'story.txt');
  } catch (error) {
    console.error('Error generating TXT:', error);
    alert('Failed to generate TXT file. Please try again.');
  }
}

export async function downloadAsDocx(content: string) {
  try {
    const paragraphs = content.split('\n').map(line => {
      if (line.startsWith('#')) {
        return new Paragraph({
          text: line.replace('#', '').trim(),
          heading: HeadingLevel.HEADING_1,
          spacing: {
            before: 400,
            after: 200
          }
        });
      }
      return new Paragraph({
        text: line,
        spacing: {
          line: 360,
          before: 200,
          after: 200
        }
      });
    });

    const doc = new Document({
      sections: [{
        properties: {},
        children: paragraphs
      }]
    });

    const blob = await Packer.toBlob(doc);
    saveAs(blob, 'story.docx');
  } catch (error) {
    console.error('Error generating DOCX:', error);
    alert('Failed to generate DOCX file. Please try again.');
  }
}